import React from "react";
import { Box, Typography, LinearProgress, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const GradientLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 12,
  borderRadius: 6,
  overflow: "hidden",
  "& .MuiLinearProgress-bar": {
    borderRadius: 6,
    backgroundImage: "linear-gradient(to right, #3b82f6, #60a5fa, #93c5fd)",
    backgroundSize: "200% auto",
    animation: "shimmer 2s linear infinite",
  },
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "0% 50%" },
    "100%": { backgroundPosition: "100% 50%" },
  },
}));

const StorageStatus = ({ storageUsed, maxStorage }) => {
  const usedGB = (storageUsed / (1024 * 1024 * 1024)).toFixed(2);
  const maxGB = (maxStorage / (1024 * 1024 * 1024)).toFixed(0);
  const percentage = ((storageUsed / maxStorage) * 100).toFixed(0);

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="bold">
          Storage Used
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {usedGB} GB / {maxGB} GB
        </Typography>
      </Box>

      <Box mt={2}>
        <GradientLinearProgress variant="determinate" value={percentage} />
        <Typography variant="caption" color="text.secondary" mt={1}>
          {percentage}% used
        </Typography>
      </Box>
    </Paper>
  );
};

export default StorageStatus;
